import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b779fa8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = {
  class: "col-1",
  style: {"text-align":"start"}
}
const _hoisted_4 = { class: "col-md-10" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = {
  class: "nav nav-tabs mb-3",
  role: "tablist"
}
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = { class: "navbar fixed-bottom navbar-dark bg-primary" }
const _hoisted_12 = { class: "container-fluid" }
const _hoisted_13 = {
  id: "status-bar-actions",
  style: {"margin-left":"auto"}
}
const _hoisted_14 = { class: "text-light" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_17 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Secondary Actions"
}
const _hoisted_18 = ["disabled"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ban" }, null, -1))
const _hoisted_20 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Primary Actions"
}
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 1,
  class: "fas fa-save"
}

import { ref, computed, onMounted, inject, nextTick } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { User} from '@/models';
import _ from 'lodash';
import { useToast } from "vue-toastification";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const actProperty: any = inject('actProperty');

const router = useRouter();
const route = useRoute();
const store = useStore();
const toasted = useToast();

const unsavedChanges = ref(false);
const isSaving = ref(false);
const toast = useToast();
const hasUnsavedChanges = computed(() => store.getters['usermanagement/hasUnsavedChanges']);

const user = computed((): User => store.getters['usermanagement/selected']);
const getUser = async (email: string): Promise<User> => {
  return store.dispatch('usermanagement/getUser', email);
};
const setUser = async (user: User) => {
  return store.commit('usermanagement/setSelectedUser', user);
};
const saveUser = async (user: User): Promise<void> => {
  return store.dispatch('usermanagement/saveUser', user)
};
const getCognitouser = async (sub: any) => {
  return store.dispatch('sysadmin/getUser', sub)
}
const resetUnsavedChanges = async () => {
  return store.commit('usermanagement/resetUnsavedChanges');
};


onMounted(async () => {
  const cognitouser = await getCognitouser(router.currentRoute.value.params.sub);
  let email = '';
  if(cognitouser) {
    email = cognitouser.findAttributeValue('email');
    if(email) {
      getUser(email)
      .then(async (u: User) => {
        if(u?.id) {
          setUser(u);
        }
        else {
          addNewUser();
        }
      })
      .catch((err: any) => {
        if(err?.response?.status === 404) {
          addNewUser();
        }
      })
    }
  }

  setTimeout(()=> resetUnsavedChanges(), 1000);
});

const addNewUser = async () => {
  let email = '';
  const cognitouser = await getCognitouser(router.currentRoute.value.params.sub);
  if(cognitouser) {
    email = cognitouser.findAttributeValue('email');
    const newuser: User = new User({email: email});
    const u: User = await store.dispatch('usermanagement/addUser', newuser);
    setUser(u);
  }
}

const saveAll = () => {
  saveUser(user.value)
  .then(() => toasted.success("Saved"));
}

const back = () => {
  const c = user.value.email.substring(0,1);
  router.push({path: `/sysadmin/userlist/${c}`});
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("i", {
          class: "fas fa-arrow-left fa-2x",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (back()))
        })
      ]),
      _createElementVNode("h1", _hoisted_4, [
        (user.value.name)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_5, _toDisplayString(user.value.name), 1))
          : (user.value.email)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_6, _toDisplayString(user.value.email), 1))
            : (_openBlock(), _createElementBlock("h1", _hoisted_7, "New user"))
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("ul", _hoisted_8, [
        _createElementVNode("li", _hoisted_9, [
          _createVNode(_component_router_link, {
            to: "userdetails",
            class: "nav-link",
            "active-class": "active"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Details ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_10, [
          _createVNode(_component_router_link, {
            to: "customerallocations",
            class: "nav-link",
            "active-class": "active"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Customers ")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    (_openBlock(), _createBlock(_component_router_view, {
      key: _ctx.$route.name,
      style: {"padding-bottom":"60px"}
    })),
    _createElementVNode("nav", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            (hasUnsavedChanges.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_15, "You have unsaved changes"))
              : (_openBlock(), _createElementBlock("span", _hoisted_16, "No unsaved changes")),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("button", {
                class: _normalizeClass(["btn btn-outline-light", { disabled: !hasUnsavedChanges.value }]),
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.cancel()), ["prevent"])),
                disabled: !hasUnsavedChanges.value
              }, [
                _hoisted_19,
                _createTextVNode(" Cancel ")
              ], 10, _hoisted_18)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("button", {
                class: _normalizeClass(["btn btn-light", { disabled: !hasUnsavedChanges.value }]),
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (saveAll()), ["prevent"])),
                disabled: isSaving.value || !hasUnsavedChanges.value
              }, [
                (isSaving.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, _hoisted_24))
                  : (_openBlock(), _createElementBlock("i", _hoisted_25)),
                _createTextVNode(" Save ")
              ], 10, _hoisted_21)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})